const NAMED_ENTITIES: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
  ndash: '–',
  mdash: '—',
  lsquo: '‘',
  rsquo: '’',
  ldquo: '“',
  rdquo: '”',
  hellip: '…',
};

const MAX_CODE_POINT = 0x10ffff;

// Single pass so an entity produced by decoding (e.g. `&#38;lt;` -> `&lt;`)
// is not decoded a second time
export const decodeHtmlEntities = (text: string): string => {
  return text.replace(
    /&(#\d+|#x[0-9a-f]+|[a-z]+);/gi,
    (match, entity: string) => {
      if (entity[0] === '#') {
        const codePoint =
          entity[1] === 'x' || entity[1] === 'X'
            ? parseInt(entity.slice(2), 16)
            : parseInt(entity.slice(1), 10);
        return codePoint <= MAX_CODE_POINT
          ? String.fromCodePoint(codePoint)
          : match;
      }
      return NAMED_ENTITIES[entity] ?? match;
    },
  );
};
